<template>
  <a-card :bordered="false">
    <!-- 表格筛选 start -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSubmit">
        <a-row :gutter="48">
          <!-- 输入关键词查找 -->
          <a-col :md="6" :sm="24">
            <a-form-item>
              <!-- 关键字搜索 -->
              <a-input v-model="queryParam.keyWord" placeholder="请输入关键字">
                <!-- 选择搜索类型 -->
                <a-select slot="addonBefore" v-model="queryParam.keyWordType" placeholder="请选择" style="width:100px">
                  <a-select-option :value="item.id" :key="item.id" v-for="item in keyWordTypeList">{{ item.name }}</a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </a-col>
          <!-- 筛选状态查找 -->
          <!--          <a-col :md="6" :sm="24">-->
          <!--            <a-form-item title="状态">-->
          <!--              <div style="display: flex;">-->
          <!--                <a-input placeholder="状态" disabled style="width: 80px;text-align: center;"></a-input>-->
          <!--                <a-select v-model="queryParam.type" placeholder="请选择">-->
          <!--                  <a-select-option :value="item.id" :key="item.id" v-for="item in dict.statusDict">{{ item.name }}</a-select-option>-->
          <!--                </a-select>-->
          <!--              </div>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <template v-if="advanced">
          </template>
          <!-- 展开或者收起筛选项 start -->
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" htmlType="submit">搜索</a-button>
              <a-button style="margin-left: 8px" @click="reset">重置</a-button>
              <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
          <!-- 展开或者收起筛选项 end -->
        </a-row>
      </a-form>
    </div>
    <!-- 表格筛选 end -->
    <!-- 表格内容操作 start -->
    <div class="table-operator">
      <a-button type="primary" @click="openAddDrawer" style="margin-right:15px;">新增角色</a-button>
      <a-radio-group style="float:right" v-model="queryParam.role_status" @change="handleSubmit">
        <a-radio-button v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
      </a-radio-group>
    </div>
    <!-- 表格内容操作 end -->
    <!-- 表格 start -->
    <tcg-table
      style="margin-top:20px;"
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="status" slot-scope="text">{{ text | valInDict(dict.statusDict) }}</span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="openViewModal(record.role_id, edit=false)">查看</a>
        </template>
        <a-divider type="vertical" />
        <template>
          <a @click="openViewModal(record.role_id, edit=true)">编辑</a>
        </template>
        <!--        <a-divider type="vertical" />-->
        <!--        <template>-->
        <!--          <a @click="openRolePermission(record)">权限设置</a>-->
        <!--        </template>-->
        <a-divider type="vertical" v-if="record.is_normal_role=='NO'"/>
        <a-popconfirm title="确定删除角色？" v-if="record.is_normal_role=='NO'" @confirm="deleteRole(record.role_id)">
          <a>删除</a>
        </a-popconfirm>
      </span>
    </tcg-table>
    <!-- 表格 end -->
    <!-- 查看弹出 -->
    <viewDrawer
      v-if="viewVisible"
      :visible="viewVisible"
      :id="role_id"
      :edit="edit"
      @hide="cancelViewDrawer"
      @finish="finishViewAndEdit"/>
    <!-- 添加角色抽屉 -->
    <addRoleDrawer v-if="addRoleDrawerVisible" :visible="addRoleDrawerVisible" @hide="handelAddDrawer" @finish="finish"></addRoleDrawer>
    <!-- 权限设置抽屉 -->
    <rolePermission
      v-if="rolePermissionVisible"
      :visible="rolePermissionVisible"
      :roleId="role_id"
      :defalutPermissionArr="defalutPermissionArr"
      @hide="handelRolePermission"
      @finish="handelRolePermission">
    </rolePermission>
  </a-card>
</template>
<script>
import { getRoleList, postDeleteRole } from '@/api/role'
import { TcgTable } from '@/components'
import viewDrawer from './Role/viewDrawer'
import addRoleDrawer from './Role/addRoleDrawer'
import rolePermission from './Role/rolePermission'
import _ from 'lodash'
import { pre } from '@/api/admin'
const keyWordTypeList = [
  {
    id: 'role_name',
    name: '角色名称'
  },
  {
    id: 'role_id',
    name: '角色ID'
  }
]
export default {
  components: {
    TcgTable,
    viewDrawer,
    addRoleDrawer,
    rolePermission
  },
  data () {
    return {
      // 添加抽屉状态开关
      addRoleDrawerVisible: false,
      // 编辑抽屉状态开关
      editDrawerVisible: false,
      // 设置权限抽屉开关
      rolePermissionVisible: false,
      // 关键字搜索类型列表
      keyWordTypeList,
      // 字典
      dict: {
        statusDict: [
          { id: 'NORMAL', name: '正常' },
          { id: 'FORBIDDEN', name: '禁用' }
        ]
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        role_status: '',
        keyWordType: 'role_name',
        keyWord: ''
      },
      // 表头
      columns: [
        {
          title: '角色ID',
          dataIndex: 'role_id',
          width: '200px'
        },
        {
          title: '角色名称',
          dataIndex: 'role_name',
          width: '200px'
        },
        {
          title: '角色备注',
          dataIndex: 'role_desc',
          width: '200px'
        },
        {
          title: '创建账号',
          dataIndex: 'create_admin',
          width: '200px'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: '200px'
        },
        {
          title: '状态',
          dataIndex: 'role_status',
          width: '200px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'id',
          width: '200px',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getRoleList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res
          })
      },
      viewVisible: false,
      role_id: '',
      defalutPermissionArr: [],
      edit: false
    }
  },
  created () {
    this.handelPre()
  },
  methods: {
    handelPre () {
      pre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict.roleDict = _.get(res, 'values.roleDict', [])
          this.dict.statusDict = _.get(res, 'values.statusDict', [])
        }
      })
    },
    // 重置按钮
    reset () {
      this.queryParam = {
        role_status: '',
        keyWordType: 'role_name',
        keyWord: ''
      }
    },
    // 关闭查看按钮事件
    cancelViewDrawer () {
      this.edit = false
      this.viewVisible = false
    },
    // 打开查看抽屉
    openViewModal (id, edit) {
      this.edit = edit
      this.role_id = id
      this.viewVisible = true
    },
    // 在查看抽屉中完成编辑
    finishViewAndEdit () {
      this.edit = false
      this.$refs.table.refresh(true)
    },
    // 完成角色创建
    finish () {
      this.handelAddDrawer()
      this.$refs.table.refresh(true)
    },
    // 打开添加用户抽屉
    openAddDrawer () {
      this.addRoleDrawerVisible = true
    },
    // 关闭添加用户抽屉
    handelAddDrawer () {
      this.addRoleDrawerVisible = false
    },
    // 打开权限设置抽屉
    openRolePermission (record) {
      this.role_id = record.role_id
      this.defalutPermissionArr = record.role_auth.split(',')
      for (const i in this.defalutPermissionArr) {
        this.defalutPermissionArr[i] = parseInt(this.defalutPermissionArr[i])
      }
      this.rolePermissionVisible = true
    },
    // 关闭权限设置抽屉
    handelRolePermission () {
      this.rolePermissionVisible = false
      this.$refs.table.refresh(true)
    },
    // 打开编辑抽屉
    openEditDrawer (id) {
      this.userId = id
      this.editDrawerVisible = true
    },
    // 关闭编辑抽屉
    handelEditDrawer () {
      this.editDrawerVisible = false
    },
    // 删除事件
    deleteRole (id) {
      postDeleteRole(id).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('删除成功')
          this.$refs.table.refresh(true)
        }
      })
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    }
  }
}
</script>
<style lang="less" scoped>
</style>
